import React from 'react';
import "./ColumnColors.scss";

const TTTTColors = {
  "Đã thanh toán": {
    color: "#00b335",
  },
  "Chưa thanh toán": {
    color: "#ff3300",
  },
  "Huỷ thanh toán": {
    color: "#b5b5b5",
  },
  "Đã tạm ứng": {
    color: "#999999",
  },
  "Đã hoàn phí": {
    color: "#007b24",
  },
  "Đã duyệt": {
    color: "#00b335",
  },
  "Có": {
    color: "#00b335",
  },
  "Không": {
    color: "#ff3300",
  },
};

const TTTTTypeColumn = ({label}: {label: string}) => {
  return (
    <div
      className="color-column"
      style={{backgroundColor: TTTTColors[label]?.color, textAlign: "center",}}
    >
      {label}
    </div>
  )
}

export default TTTTTypeColumn;